module.exports = __webpack_public_path__ + "img/sell_badge-percent.9fd2e1af.svg";